import api from '@/clientRequests/api'
import { apiRoutes, DELIVERY_WINDOWS } from '@/config/globals'
import { DELIVERY_ESTIMATE_QUERY } from './queries'

export const getDeliveryEstimate = async (zipCode, state) => {
    try {
        if (!zipCode || !state) {
            return DELIVERY_WINDOWS.fedex
        }

        const query = DELIVERY_ESTIMATE_QUERY
        const variables = {
            zipCode,
            state
        }

        const { getDelieveryEstimate } = await api(apiRoutes.cartCheckout, {
            query,
            variables
        })

        return getDelieveryEstimate
    } catch (error) {
        console.error(error.message)
        return DELIVERY_WINDOWS.fedex
    }
}
